import StepFourIcon from './component.jsx'
export default StepFourIcon
